import Link from "next/link";
import { APPLICATION_ROUTES } from "../../shared-logic";

export const BrandingTooltip = () => {
    return (
        <>
            Branding can be set on your{" "}
            <Link href={APPLICATION_ROUTES.PORTFOLIO_APP} passHref>
                Homepage
            </Link>
        </>
    );
};
